<template>
  <v-sheet color="grey" id="sobre">
    <v-container class="py-15">
      <v-row class="align-center py-15">
        <v-col cols="12" md="6" lg="5">
          <div class="d-flex" style="gap: 10px">
            <figure>
              <img :src="logo" class="img-title" />
            </figure>
            <div>
              <TitleWidget :align="'left'">Sobre nós</TitleWidget>
              {{ item.title }}
            </div>
          </div>
          <img
            v-if="smAndDown"
            class="about-img mt-5"
            :src="this.files + item.img"
          />
          <div class="my-6" v-html="item.text"></div>
          <ButtonWidget to="/sobre">Conheça mais</ButtonWidget>
        </v-col>
        <v-col v-if="!smAndDown" cols="12" md="6" lg="6" offset-lg="1">
          <img class="about-img" :src="this.files + item.img" />
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import logo from "@/assets/img/logo-about.png";
import TitleWidget from "../widgets/TitleWidget.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

export default {
  data: () => {
    return {
      logo: logo,
    };
  },
  computed: {
    item() {
      return this.$rest("about").item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss">
#sobre {
  color: var(--v-text-base);
  .img-title {
    max-width: 100%;
  }
  padding-top: 100px;
  margin-top: -100px;
  .about-img {
    border-top-left-radius: 100px;
    border-bottom-right-radius: 100px;
    max-width: 100%;
  }
}
</style>
